import { Person } from '@/models/Person';

export enum PushNotificationTypes {
    GET_PUSH_NOTIFICATION_LIST_REQUEST = '@pushNotification/GET_PUSH_NOTIFICATION_LIST_REQUEST',
    ALL_PUSH_NOTIFICATION_LIST_SUCCESS = '@pushNotification/ALL_PUSH_NOTIFICATION_SUCCESS',
    UNCHECKED_PUSH_NOTIFICATION_LIST_SUCCESS = '@pushNotification/UNCHECKED_PUSH_NOTIFICATION_SUCCESS',
    GET_PUSH_NOTIFICATION_LIST_FAILURE = '@pushNotification/GET_PUSH_NOTIFICATION_FAILURE',

    UPDATE_PUSH_NOTIFICATION_STATUS = '@pushNotification/UPDATE_PUSH_NOTIFICATION_STATUS',
    UPDATE_PUSH_NOTIFICATION_STATUS_SUCCESS = '@pushNotification/UPDATE_PUSH_NOTIFICATION_STATUS_SUCCESS',
    UPDATE_PUSH_NOTIFICATION_STATUS_FAILURE = '@pushNotification/UPDATE_PUSH_NOTIFICATION_STATUS_FAILURE',
    CLEAR_UNCHECKED_NOTIFICATIONS = '@pushNotification/CLEAR_UNCHECKED_NOTIFICATIONS',
    CLEAR_ALL_NOTIFICATIONS = '@pushNotification/CLEAR_ALL_NOTIFICATIONS',
}

export interface PushNotification {
    id: number;
    person: Person;
    message: string;
    title: string;
    creationDate: number;
    checked: boolean;
    dynamicAttributes: DynamicAttributes;
}

export interface DynamicAttributes {
    entityId: number;
    entityType: string;
}

export interface PushNotificationViewData {
    list: PushNotification[];
    total: number;
}

export interface PushNotificationState {
    data: {
        [key: string]: PushNotificationViewData;
        listAllPushNotification: PushNotificationViewData;
        listUncheckedPushNotification: PushNotificationViewData;
    };

    loading: boolean;
    hasError: boolean;
}
